import { useCallback, useEffect, useMemo, useState } from 'react';

import { Button, Descriptions, Modal, Popconfirm } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';

import { PaginationTable, SearchBar, SearchBarColumns } from 'components/elements';

import { DEFAULT_PAGE_SIZE, usePagination } from 'hooks';

import {
    RequestGetSpaceList,
    ResponseSpaceList,
    SpaceFileType,
    SpaceListDetail,
} from 'types/space';

import { StyledFileListWrapper, StyledHeaderTitle } from './styles';

export const Space = () => {
    const [spaceList, setSpaceList] = useState<ResponseSpaceList>({
        page: 1,
        size: DEFAULT_PAGE_SIZE,
        first: true,
        last: true,
        totalPages: 0,
        totalElements: 0,
        content: [],
    });

    const [requestGetSpaceList, setRequestGetSpaceList] = useState<RequestGetSpaceList>({
        page: 1,
        size: DEFAULT_PAGE_SIZE,
    });

    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

    const [filePopupCtr, setFilePopupCtr] = useState<{
        show: boolean;
        fileDetail?: SpaceFileType;
    }>({
        show: false,
        fileDetail: undefined,
    });

    const searchData: SearchBarColumns[] = useMemo(() => {
        return [
            {
                key: 'searchType',
                label: '검색 구분',
                type: 'select',
                span: 6.5,
                customProps: { style: { width: 130 } },
                initValue: 'ALL',
                options: [
                    { label: '전체', value: 'ALL' },
                    { label: '스페이스제목', value: 'TITLE' },
                    { label: '생성자', value: 'CONSTRUCTOR' },
                ],
            },
            {
                key: 'keyword',
                label: '검색어',
                disableLabel: true,
                type: 'input',
                span: 12,
                placeholder: '검색어를 입력해주세요.',
                customProps: { style: { width: 360 } },
            },
            {
                key: 'space',
                label: '스페이스 속성',
                type: 'radio',
                span: 24,
                initValue: 'ALL',
                options: [
                    { label: '전체', value: 'ALL' },
                    { label: '고정', value: 'FIX' },
                    { label: '일반', value: 'NORMAL' },
                ],
            },
        ];
    }, []);

    const columns: ColumnsType<SpaceListDetail> = [
        {
            title: '속성',
            key: 'space',
            dataIndex: 'space',
            align: 'center' as 'center',
        },
        {
            title: '소속',
            key: 'belong',
            dataIndex: 'belong',
            align: 'center' as 'center',
        },
        {
            title: '스페이스 생성자 닉네임',
            key: 'nickname',
            dataIndex: 'nickname',
            align: 'center' as 'center',
        },
        {
            title: '스페이스명',
            key: 'spaceName',
            dataIndex: 'spaceName',
            align: 'center' as 'center',
        },
        {
            title: '인원',
            key: 'personnel',
            dataIndex: 'personnel',
            align: 'center' as 'center',
        },
        {
            title: '룸 생성 일시',
            key: 'createDt',
            dataIndex: 'createDt',
            align: 'center' as 'center',
        },
        {
            title: '공유된 파일(공유, 로드 전체파일)',
            key: 'fileList',
            dataIndex: 'fileList',
            align: 'center' as 'center',
            width: '30%',
            render: (_, record) => {
                const fileList = record.fileList;
                return (
                    <StyledFileListWrapper>
                        {fileList.length > 0
                            ? fileList.map((file, index) => (
                                  <a
                                      key={index}
                                      onClick={() =>
                                          setFilePopupCtr({
                                              show: true,
                                              fileDetail: file,
                                          })
                                      }
                                  >
                                      {file.fileName}
                                      {index < fileList.length - 1 && ','}
                                  </a>
                              ))
                            : '-'}
                    </StyledFileListWrapper>
                );
            },
        },
    ];

    const onSearch = (values: any) => {};

    const onSearchReset = () => {};

    const pagination = usePagination({
        total: spaceList.totalElements,
        page: requestGetSpaceList.page,
        pageSize: requestGetSpaceList.size,
        updateFilter: (page, size) => {
            setRequestGetSpaceList({ page, size });
        },
    });

    const handleGetSpaceList = useCallback((requestGetNoticeList: RequestGetSpaceList) => {
        console.log(requestGetNoticeList);
        //스페이스 리스트 api 조회 영역
        setSpaceList({
            first: false,
            last: true,
            page: 1,
            size: 10,
            totalElements: 1390,
            totalPages: 139,
            content: [
                {
                    spaceId: 1,
                    space: '일반/비밀번호',
                    belong: '삼성 eng',
                    nickname: '홍길동',
                    spaceName: '삼성 eng 연습',
                    personnel: '8/32',
                    createDt: '2024-04-18 09:00:00',
                    fileList: [],
                },
                {
                    spaceId: 2,
                    space: '고정/비밀번호',
                    belong: '삼성 eng',
                    nickname: '삼성리더',
                    spaceName: '삼성 eng 실무룸',
                    personnel: '30/32',
                    createDt: '2024-04-18 09:00:00',
                    fileList: [
                        {
                            fileId: 1,
                            belong: '삼성 eng',
                            user: '김초롱',
                            createDt: '2024-04-18 10:10:10',
                            fileName: '아무_이미지.jpeg',
                            fileUrl:
                                'data:image/png;base64,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',
                        },
                        {
                            fileId: 2,
                            belong: '삼성 eng',
                            user: '김초롱',
                            createDt: '2024-04-18 10:10:10',
                            fileName: '아무_이미지.mp4',
                            fileUrl: '',
                        },
                        {
                            fileId: 3,
                            belong: '삼성 eng',
                            user: '김초롱',
                            createDt: '2024-04-18 11:11:11',
                            fileName: 'Bag_3D.obj',
                            fileUrl: '',
                        },
                    ],
                },
                {
                    spaceId: 3,
                    space: '일반',
                    belong: 'LG',
                    nickname: '작업자',
                    spaceName: 'LG 테스트',
                    personnel: '20/32',
                    createDt: '2024-04-18 09:00:00',
                    fileList: [],
                },
                {
                    spaceId: 4,
                    space: '고정',
                    belong: 'LG',
                    nickname: 'LG리더',
                    spaceName: 'LG 테스트2',
                    personnel: '32/32',
                    createDt: '2024-04-18 09:00:00',
                    fileList: [],
                },
                {
                    spaceId: 5,
                    space: '일반',
                    belong: 'LG',
                    nickname: '작업자',
                    spaceName: 'LG 테스트3',
                    personnel: '20/32',
                    createDt: '2024-04-18 09:00:00',
                    fileList: [],
                },
                {
                    spaceId: 6,
                    space: '고정',
                    belong: 'LG',
                    nickname: 'LG리더',
                    spaceName: 'LG 테스트4',
                    personnel: '32/32',
                    createDt: '2024-04-18 09:00:00',
                    fileList: [],
                },
                {
                    spaceId: 7,
                    space: '일반',
                    belong: 'LG',
                    nickname: '작업자',
                    spaceName: 'LG 테스트5',
                    personnel: '20/32',
                    createDt: '2024-04-18 09:00:00',
                    fileList: [],
                },
                {
                    spaceId: 8,
                    space: '고정',
                    belong: 'LG',
                    nickname: 'LG리더',
                    spaceName: 'LG 테스트6',
                    personnel: '32/32',
                    createDt: '2024-04-18 09:00:00',
                    fileList: [],
                },
                {
                    spaceId: 9,
                    space: '일반',
                    belong: 'LG',
                    nickname: '작업자',
                    spaceName: 'LG 테스트7',
                    personnel: '20/32',
                    createDt: '2024-04-18 09:00:00',
                    fileList: [],
                },
                {
                    spaceId: 10,
                    space: '고정/비밀번호',
                    belong: 'LG',
                    nickname: 'LG그룹장',
                    spaceName: 'LG 테스트8',
                    personnel: '32/32',
                    createDt: '2024-04-18 09:00:00',
                    fileList: [],
                },
            ],
        });
    }, []);

    const handleDelete = useCallback(() => {
        console.log(selectedKeys);
    }, [selectedKeys]);

    const handleFileDelete = () => {
        console.log(filePopupCtr.fileDetail?.fileId);
        //file삭제 api
        handleFilePopupClose();
    };

    const handleFilePopupClose = () => {
        setFilePopupCtr({
            show: false,
            fileDetail: undefined,
        });
    };

    useEffect(() => {
        handleGetSpaceList(requestGetSpaceList);
    }, [requestGetSpaceList]);

    return (
        <>
            <div style={{ marginLeft: '2%' }}>
                <StyledHeaderTitle>스페이스 관리</StyledHeaderTitle>
                <SearchBar columns={searchData} onSearch={onSearch} onReset={onSearchReset} />
                <PaginationTable
                    rowKey="spaceId"
                    rowSelection={{
                        selectedRowKeys: selectedKeys,
                        onChange: (selectRowKeys) => {
                            setSelectedKeys(selectRowKeys as string[]);
                        },
                    }}
                    customRight={
                        <>
                            <Button disabled={selectedKeys.length === 0}>
                                <DownloadOutlined />
                                Excel
                            </Button>

                            <Popconfirm
                                placement="topLeft"
                                title={
                                    <>
                                        선택한 스페이스를 정말로 삭제하시겠습니까?
                                        <br />
                                        (삭제된 스페이스는 복구할 수 없습니다)
                                    </>
                                }
                                onConfirm={handleDelete}
                                okText="삭제"
                                cancelText="취소"
                                disabled={selectedKeys.length === 0}
                            >
                                <Button
                                    style={{ marginLeft: 10 }}
                                    type="primary"
                                    danger
                                    disabled={selectedKeys.length === 0}
                                >
                                    삭제
                                </Button>
                            </Popconfirm>
                        </>
                    }
                    pagination={pagination}
                    columns={columns}
                    showPageSize={false}
                    dataSource={spaceList.content || []}
                />
            </div>
            <Modal
                title="업로드 파일"
                open={filePopupCtr.show}
                onCancel={handleFilePopupClose}
                width={500}
                footer={[
                    <Popconfirm
                        placement="bottom"
                        title={
                            <>
                                선택한 스페이스를 정말로 삭제하시겠습니까?
                                <br />
                                (삭제된 스페이스는 복구할 수 없습니다)
                            </>
                        }
                        onConfirm={handleFileDelete}
                        okText="삭제"
                        cancelText="취소"
                    >
                        <Button type="primary" danger>
                            삭제
                        </Button>
                    </Popconfirm>,
                ]}
            >
                <Descriptions bordered>
                    <Descriptions.Item label="소속" span={3}>
                        {filePopupCtr.fileDetail?.belong}
                    </Descriptions.Item>
                    <Descriptions.Item label="업로드 유저명" span={3}>
                        {filePopupCtr.fileDetail?.user}
                    </Descriptions.Item>
                    <Descriptions.Item label="업로드 일시" span={3}>
                        {filePopupCtr.fileDetail?.createDt}
                    </Descriptions.Item>
                    <Descriptions.Item label="파일명" span={3}>
                        {filePopupCtr.fileDetail?.fileName}
                    </Descriptions.Item>
                </Descriptions>
                <div
                    style={{
                        border: '1px solid #f0f0f0',
                        borderTop: 'none',
                        textAlign: 'center',
                        padding: 20,
                    }}
                >
                    {filePopupCtr.fileDetail &&
                        getFileType(
                            filePopupCtr.fileDetail.fileName,
                            filePopupCtr.fileDetail.fileUrl
                        )}
                </div>
            </Modal>
        </>
    );
};

const getFileType = (fileName: string, fileUrl: string) => {
    const extension = fileName.split('.')[1];
    switch (extension) {
        case 'jpeg':
        case 'png':
            return <img src={fileUrl} />;
        case 'mp4':
            return (
                <video
                    src={fileUrl}
                    controls
                    controlsList="nodownload"
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    playsInline
                ></video>
            );
        case 'obj':
            return '3D';
        default:
            return '';
    }
};
